export const BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING =
  "BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING"
export const BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_SUCCESS =
  "BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_SUCCESS"
export const BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_FAILED =
  "BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_FAILED"
